import { http } from '@/core/helpers/axiosHelper';
import { ApiResource } from '@/core/models/ApiResource.interface';
import { LocationQuery } from 'vue-router';
import { CreatePerformanceCounter, PerformanceCounter } from './performance-counter.interface';

export class PerformanceCounterService {
   async getPerformanceCounters(employeeId: number, query?: LocationQuery) {
      const response = await http.get<ApiResource<Array<PerformanceCounter>>>(`/employees/${employeeId}/performance-counters`, {
         params: { ...query },
      });
      return response.data;
   }

   async getPerformanceCounter() {
      throw Error('Method not implemented');
   }

   async postPerformanceCounter(employeeId: number, performanceCounter: CreatePerformanceCounter) {
      const response = await http.post<ApiResource<PerformanceCounter>>(
         `/employees/${employeeId}/performance-counters`,
         performanceCounter,
      );
      return response.data;
   }

   async putPerformanceCounter() {
      throw Error('Method not implemented');
   }

   async deletePerformanceCounter() {
      throw Error('Method not implemented');
   }
}
